import React, {ReactNode} from "react";
import {UIText} from "../enums/UIText/UIText";
import Home from "./Home/Home";
import About from "./About/About";
import Price from "./Price/Price";
import Education from "./Education/Education";
import Contacts from "./Contacts/Contacts";
import Profile from "./Profile/Profile";
import Demo from "./Demo/Demo";
import Documents from "./Documents/Documents";
import Cookies from "./Cookies/Cookies";

export interface IPage {
    inNavigation: boolean
    status: boolean,
    path: string,
    title: any,
    element: ReactNode
}

export const pages: IPage[] = [
    {
        inNavigation: false,
        status: true,
        path: '/',
        title: UIText.mis,
        element: <Home/>
    },
    {
        inNavigation: true,
        status: true,
        path: '/about',
        title: UIText.nav.aboutSystem,
        element: <About/>
    },
    {
        inNavigation: true,
        status: true,
        path: '/demo',
        title: UIText.nav.demo,
        element: <Demo/>
    },
    {
        inNavigation: true,
        status: true,
        path: '/price',
        title: UIText.nav.price,
        element: <Price/>
    },
    // {
    //     inNavigation: true,
    //     status: true,
    //     path: '/instructions',
    //     title: UIText.nav.instructions,
    //     element: <Instructions/>
    // },
    {
        inNavigation: true,
        status: false,
        path: '/education',
        title: UIText.nav.educationalProgram,
        element: <Education/>
    },
    {
        inNavigation: true,
        status: true,
        path: '/contacts',
        title: UIText.nav.contacts,
        element: <Contacts/>
    },
    {
        inNavigation: false,
        status: true,
        path: '/profile',
        title: UIText.nav.contacts,
        element: <Profile/>
    },
    // {
    //     inNavigation: true,
    //     status: true,
    //     path: '/technicalsupport',
    //     title: UIText.nav.technicalsupport,
    //     element: <TechnicalSupport/>
    // }
    {
        inNavigation: true,
        status: true,
        path: '/documents',
        title: UIText.nav.documents,
        element: <Documents/>
    },
    {
        inNavigation: false,
        status: true,
        path: '/cookies',
        title: UIText.nav.cookies,
        element: <Cookies/>
    },
    {
        inNavigation: false,
        status: true,
        path: '*',
        title: '',
        element: <><h1>404</h1></>
    },
]